import { useCallback } from 'react';

const MapInitializer = ({ onMapCreated, logMapEvent }) => {
    const initializeMap = useCallback((mapRef, initialLocation = null) => {
        if (!window.mapkit || !mapRef.current) {
            logMapEvent('Map Initialization Failed', { 
                reason: 'Missing mapkit or mapRef',
                hasMapKit: !!window.mapkit,
                hasMapRef: !!mapRef?.current,
                mapKitType: typeof window.mapkit
            });
            return;
        }

        try {
            const mapToken = process.env.REACT_APP_APPLE_MAP_KEY;
            logMapEvent('Initializing Map', { 
                initialLocation,
                hasToken: !!mapToken,
                tokenLength: mapToken?.length 
            });
            
            window.mapkit.init({
                authorizationCallback: (done) => {
                    console.log('Auth callback called, providing token');
                    done(mapToken);
                },
            });

            const newMap = new window.mapkit.Map(mapRef.current, {
                mapType: window.mapkit.Map.MapTypes.Hybrid, // MutedStandard, Hybrid, Satellite, Standard
                showsCompass: window.mapkit.FeatureVisibility.Hidden,
                showsMapTypeControl: false,
                showsScale: window.mapkit.FeatureVisibility.Hidden,
                isZoomEnabled: true,
                isScrollEnabled: true,
                showsZoomControl: true,
            });

            newMap.addEventListener('region-change-end', () => {
                logMapEvent('Region Changed', {
                    center: newMap.center,
                    region: newMap.region
                });
            });

            if (initialLocation) {
                logMapEvent('Setting Initial Location', initialLocation);
                const coordinate = new window.mapkit.Coordinate(initialLocation.latitude, initialLocation.longitude);
                const region = new window.mapkit.CoordinateRegion(
                    coordinate,
                    new window.mapkit.CoordinateSpan(0.005, 0.005)
                );
                newMap.region = region;
            }

            onMapCreated(newMap);
        } catch (error) {
            logMapEvent('Map Initialization Error', error);
            console.error('Error initializing map:', error);
            onMapCreated(null);
        }
    }, [logMapEvent, onMapCreated]);

    return {
        initializeMap
    };
};

export default MapInitializer; 